import styled from 'styled-components';

export const AboutMainModalWrapper = styled.div`
  .about-burger-wrapper {
    cursor: pointer;
    width: 35px;
    height: 35px;
  }
`;

export const AboutMainModalContentWrapper = styled.div`
  margin-top: 35px;
  margin-bottom: 35px;

  .about-links {
    cursor: pointer;
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    border-bottom: 1px solid #eaeaea;
    color: #061737;
    padding: 10px 0;
    letter-spacing: 0.5px;

    .socials-block {
      margin-top: 20px;
      display: flex;
      justify-content: center;

      a {
        padding: 0 10px;
      }
    }
  }

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    color: #061737;
    margin-bottom: 20px;
  }

  .about-paragraph {
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
    text-align: center;
    color: #080713;
    padding: 12px 0;
    border-bottom: 1px solid #eaeaea;

    a {
      color: #0047cd;
    }
  }

  .contact-with-hotel {
    text-align: center;
    margin-top: 30px;
    font-size: 17px;
  }

  .social-icons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 25px;
  }

  button {
    background: #35cd8c;
    box-shadow: 0 10px 30px rgba(25, 191, 136, 0.21);
    border-radius: 15px;
    height: 70px;
    padding: 12px 18px;
    font-weight: 500;
    font-size: 23px;
    line-height: 28px;
    color: #ffffff;
    text-align: center;
    margin: 20px 20% 0;
    width: 60%;
  }

  .logo {
    padding: 0 40px;
  }

  .whats-Up-icon {
    margin-left: 10%;
    width: 20%;
    &:hover {
      background: forestgreen;
    }
  }
`;
